import { FormControl } from 'baseui/form-control'
import { TYPE } from 'baseui/select'
import SDSelect from '@/shared/components/SDComponents/SDSelect/SDSelect'

interface SelectOption {
  label: string
  id: string | number
}

interface GenericSelectProps {
  onChange: (params: { value: SelectOption[] }) => void
  list: Record<string, unknown> | unknown[]
  getId: (element: unknown) => string | number
  getName: (element: unknown) => string
  filterId: string | number
  label: string
}

const GenericSelect = ({ onChange, list, getId, getName, filterId, label }: GenericSelectProps) => {
  const selected: SelectOption[] = []
  const options: SelectOption[] = []

  if (list) {
    for (const [, element] of Object.entries(list)) {
      const elementId = getId(element)
      const data: SelectOption = {
        label: getName(element),
        id: elementId,
      }
      options.push(data)

      if (elementId?.toString() === filterId?.toString()) {
        selected.push(data)
      }
    }
  }

  return (
    <FormControl label={label}>
      {/* @ts-expect-error SDSelect is a JS component without proper TS types */}
      <SDSelect type={TYPE.search} options={options} value={selected} onChange={onChange} />
    </FormControl>
  )
}

export default GenericSelect
